import SimpleFormPage from "../common/SimpleFormPage";
import DpiTypeFields from "./DpiTypeFields";

export default function NewDpiType() {
  return (
    <SimpleFormPage title="Nuova categoria DPI">
      <DpiTypeFields />
    </SimpleFormPage>
  );
}
